<template>
  <div id="ProductDetail" style="margin: 0 auto;    background: white;">
    <div ref="header" class="header-box">
    </div>
    <el-table ref="table" :data="tableData" stripe size="mini" :height="screenHeight" :highlight-current-row="true">
      <el-table-column prop="date" label="日期" width="80px" align="right" sortable>
      </el-table-column>
      <!-- <el-table-column prop="seller-sku" label="SKU" width="200px" align="center" sortable>
      </el-table-column> -->
      <el-table-column prop="productName" label="名称" width="70px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="model" label="机型" width="60px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="productColorName" label="颜色" width="40px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="speed" label="增速" width="40px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="inventoryCount" label="可用" width="40px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="reservedQuantity" label="转运" width="40px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="inboundQuantity" label="入库" width="40px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="inventoryDay" label="库存天数" width="55px" align="right" sortable>
        <template v-slot="scope">
          <div :class="getInventoryDayStyleClass(scope.row.inventoryDay)">{{ scope.row.inventoryDay }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableInventoryDay" label="可用库存天数" width="55px" align="right" sortable>
        <template v-slot="scope">
          <div :class="getInventoryDayStyleClass(scope.row.availableInventoryDay)">{{ scope.row.availableInventoryDay }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="recommendCount" label="采购" width="40px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="totalVisit" label="合计访客" class-name="lightBlueBg" width="55px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="totalView" label="页面浏览量" class-name="lightBlueBg" width="60px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="orders" label="当日订单" class-name="lightBlueBg" width="50px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="rank" label="排名" class-name="lightBlueBg" width="60px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="conversionRate" label="转化率" class-name="lightBlueBg" width="50px" align="right" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.conversionRate>=0 ? Math.round(scope.row.conversionRate*10000)/100 + "%" : 0 + "%"  }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="last7DayCount" label="七日订单" class-name="lightBlueBg" width="50px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="price" label="价格" class-name="lightBlueBg" width="40px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="normalVisit" label="自然访客" class-name="lightGreenBg" width="50px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="normalOrders" label="自然订单数" class-name="lightGreenBg" width="50px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="normalConversionRate" label="自然转化率" class-name="lightGreenBg" width="50px" align="right" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.normalConversionRate>=0 ? Math.round(scope.row.normalConversionRate*10000)/100 + "%" : 0 }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="adImpressions" label="广告展现" class-name="lightYellowBg" width="60px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="adVisit" label="广告访客" class-name="lightYellowBg" width="50px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="adSpend" label="广告花费" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adSpend)).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="total7DayAdSkuCount" label="本SKU订单数" class-name="lightYellowBg" width="50px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="adOrders" label="广告订单数" class-name="lightYellowBg" width="50px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="adSales" label="广告销售额" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adSales)).toFixed(2) }}
        </template>
      </el-table-column>

      <el-table-column prop="adCpc" label="广告CPC" width="50px" class-name="lightYellowBg" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adCpc)).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="adClickRate" label="广告点击率" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adClickRate*100)).toFixed(2) + "%" }}
        </template>
      </el-table-column>
      <el-table-column prop="adConversionRate" label="广告转化率" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adConversionRate*100)).toFixed(2) + "%" }}
        </template>
      </el-table-column>
      <el-table-column prop="adROAS" label="广告ROAS" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adROAS)).toFixed(2)  }}
        </template>
      </el-table-column>
      <el-table-column prop="adManualKWSpend" label="手动关键词广告花费" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adManualKWSpend)).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="adAutoCloseSpend" label="紧密匹配广告花费" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adAutoCloseSpend)).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="adAutoLooseSpend" label="广泛匹配广告花费" class-name="lightYellowBg" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.adAutoLooseSpend)).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="recommendPrice" label="推荐价格" width="55px" align="right" sortable>
        <template v-slot="scope">
          <div :class="getRecommendPriceStyleClass(scope.row)">{{ scope.row.recommendPrice }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="sum" label="广告状态" width="60px" align="right">
        <template v-slot="scope">
          <el-switch v-model="scope.row.adState" active-value="enabled" inactive-value="paused" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </template>
      </el-table-column>
      <!-- <el-table-column v-for="(date,index) in dateList" :key="date" :label="date" width="45px" sortable>
        <template v-slot="scope">
          <div class="row-item">{{ scope.row["orderCount"+(index+1)] }}</div>
          <div class="row-item" v-if="scope.row['seller-sku'].indexOf('合计') == -1 && params.viewType == 1">{{ scope.row["orderPrice"+(index+1)] }}</div>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import {
  requestModules
} from '@r'
export default {
  data() {
    return {
      screenHeight: document.body.clientHeight - 64 - 68,
      tableData: [],
      params: {
        asin: this.$route.query.asin
      },
      dateList: []
    };
  },
  mounted() {
    // this.screenHeight = screen.availHeight - 55 - this.$refs.header.clientHeight - this.$refs.pageNav.clientHeight
    for (let i = 1; i < 31; i++) {
      let date = new Date(new Date().getTime() - i * 24 * 60 * 60 * 1000).format("MM-dd");
      this.dateList.push(date);
      console.log(date)
    }

    this.getData()
  },
  methods: {
    getData() {
      console.log("fetchProductData")
      requestModules.fetchProductData(this.params).then(res => {
        this.tableData = res.ldata;
      });
    },

    getInventoryDayStyleClass(inventoryDay) {
      let styleClass = "";
      inventoryDay <= 15 && (styleClass = "redBg");
      inventoryDay > 15 && inventoryDay <= 30 && (styleClass = "yellowBg");
      inventoryDay > 30 && inventoryDay <= 90 && (styleClass = "greenBg");
      inventoryDay > 90 && (styleClass = "redText");
      return styleClass;
    },
    getAvailableInventoryDayStyleClass(inventoryDay) {
      let styleClass = "";
      inventoryDay <= 10 && (styleClass = "redBg");
      inventoryDay > 10 && inventoryDay <= 20 && (styleClass = "yellowBg");
      inventoryDay > 20 && inventoryDay <= 60 && (styleClass = "greenBg");
      inventoryDay > 60 && (styleClass = "redText");
      return styleClass;
    },
    getRecommendPriceStyleClass(row) {
      let styleClass = "";
      row.recommendPrice - row.price > 0 && (styleClass = "greenBg");
      row.recommendPrice - row.price < 0 && (styleClass = "redBg");
      return styleClass;
    },
    prevBtnClick() {

    },
    nextBtnClick() {

    }
  },
  computed: {
    highlightCellStyle() {
      return {
        backgroundColor: 'yellow'
      };
    },
  }
};
</script>

<style lang="scss">
#ProductDetail {
  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
    line-height: 14px;
    text-align: right;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }
  }

  .el-table tr:hover {
    background-color: #f9f981;
  }

  .el-table tr:hover td {
    background-color: transparent;
  }

  .el-table .current-row {
    background-color: #f9f981;

    .el-table__cell{
      background-color: #f9f981;
    }
  }

  .upload-demo {
    text-align: right;
  }

  .lightBlueBg {
    background-color: #e5e5ff;
  }
  .lightGreenBg {
    background-color: rgb(198, 239, 198);
  }
  .lightYellowBg {
    background-color: rgb(241, 241, 207);
  }
}
</style>
